import React from "react";
import { withRouter } from "us.common/wIthRouter";
import IO from "us.collection.input-output";

interface ICnt_ATGHome {}

const Cnt_ATGHome: React.FC<ICnt_ATGHome> = (props) => {
  return <IO.Components.ATGHome.ATGHome {...props} />;
};

export default withRouter(Cnt_ATGHome);
